import React, { FunctionComponent } from "react";

import { FlexDirection, FlexGrow, Layout } from "@multiweb/reactComponents";
import { createQA } from "@multiweb/reactUtils";
import { FavoriteMenuItem as FavoriteMenuItemType } from "../../favoriteItems/types";
import { LOC_KEY_QUICK_ACCESS_MENU_FAVORITES } from "../../locKeys";
import { MenuNavigationSectionType } from "../../navigation";
import { MenuItem } from "../MenuItem";
import { ProfileItem } from "../ProfileItem";

export type QuickAccessFavoriteItemsComponentProps = {
    /** Pole identifikátorů oblíbených položek */
    readonly favoriteFormItems: readonly FavoriteMenuItemType[];
};

/** Vykresluje obsah části pro oblíbené položky v menu Rychlého přístupu. */
export const QuickAccessFavoriteComponent: FunctionComponent<QuickAccessFavoriteItemsComponentProps> = ({ favoriteFormItems }) => (
    <div {...createQA("quick-access-favorite-items")} >
        {
            <Layout
                flexDirection={FlexDirection.column}
                flexGrow={FlexGrow.one}
            >
                {favoriteFormItems && favoriteFormItems.map(({ formId, profileId }) => (
                    <Layout
                        flexDirection={FlexDirection.column}
                        flexGrow={FlexGrow.one}
                        key={`${profileId}_${formId}`}
                    >
                        {profileId ?
                            <ProfileItem key={profileId} parentFormItemId={formId} {...{ profileId, section: MenuNavigationSectionType.quickAccessFavorite }} qa= { LOC_KEY_QUICK_ACCESS_MENU_FAVORITES }/>
                            : <MenuItem formItemId={formId} {...{ section: MenuNavigationSectionType.quickAccessFavorite, qa: LOC_KEY_QUICK_ACCESS_MENU_FAVORITES }} /> }
                    </Layout>
                ))}
            </Layout>
        }
    </div>);
